import { render, staticRenderFns } from "./SelectBoxV2.vue?vue&type=template&id=00e79bc8&scoped=true"
import script from "./SelectBoxV2.vue?vue&type=script&lang=ts"
export * from "./SelectBoxV2.vue?vue&type=script&lang=ts"
import style0 from "./SelectBoxV2.vue?vue&type=style&index=0&id=00e79bc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e79bc8",
  null
  
)

export default component.exports